import React, { useEffect, useState } from "react";
import "./manageProduct.scss";
import SnackbarAlert from "../../../components/snackbarAlert/snackbarAlert";
import snackbarStore from "../../../stores/snackbarStore";
import categoryStore from "../../../stores/categoryStore";
import { useNavigate, useParams } from "react-router-dom";
import {
  Autocomplete,
  Backdrop,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  FormLabel,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Tooltip,
} from "@mui/material";
import TwoBreadcrumb from "../../../components/breadcrumbs/TwoBreadcrumb";
import IOSSwitch from "../../../components/iosSwitch/IOSSwitch";

// Image
import UploadLogoImage from "../../../assets/upload-icon.png";
import demoImage from "../../../assets/demo/bag.jpg";

// Icon
import CloseIcon from "@mui/icons-material/Close";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import PercentIcon from "@mui/icons-material/Percent";
import QuillEditor from "../../../components/quillEditor/QuillEditor";
import productStore from "../../../stores/productStore";
import {
  HowManyColorsUsed,
  ProductColors,
  ProductSizes,
} from "../../../assets/data";
import { PRODUCT_IMAGE_URL } from "../../../constant";
import searchTagStore from "../../../stores/searchTagStore";
import sidebarActivePage from "../../../stores/sidebarActivePage";

// set Icon
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const ManageProduct = () => {
  const SnackbarStore = snackbarStore();
  const CategoryStore = categoryStore();
  const ProductStore = productStore();
  const SearchTagStore = searchTagStore();
  const SidebarActivePage = sidebarActivePage();
  const params = useParams();
  const navigate = useNavigate();

  const [selectedImage, setSelectImage] = useState([]);
  const [selectedTags, setSelectTags] = useState([]);
  var data = ["No Data"];
  const [isLoading, setIsLoading] = useState(true);

  const fillData = async () => {
    ProductStore.clearProductForm();
    if (params.productID !== undefined) {
      if (params.productID === "details/") {
        return navigate("/product");
      }
      const res = await ProductStore.fillUpdateProduct({
        _id: params.productID,
      });
      if (res === false) return navigate("/product");
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
    await CategoryStore.fetchCategory();
  };

  useEffect(() => {
    SidebarActivePage.setIsActive({ setPage: "Product" });
    fillData();
  }, []);

  useEffect(() => {
    if (ProductStore.productForm.tagID && SearchTagStore.searchTags) {
      const data = [];
      SearchTagStore.searchTags.map((item) => {
        ProductStore.productForm.tagID.map((id) => {
          return id === item._id && data.push(item);
        });
      });
      setSelectTags(data);
    }
  }, [ProductStore.productForm.tagID]);

  const handleClick = async (e) => {
    e.preventDefault();
    if (ProductStore.productForm.productName === "") {
      ProductStore.checkValidation({ name: "productName", value: true });
    } else {
      ProductStore.checkValidation({ name: "productName", value: false });
    }
    if (ProductStore.productForm.productContent === "") {
      ProductStore.checkValidation({ name: "productContent", value: true });
    } else {
      ProductStore.checkValidation({ name: "productContent", value: false });
    }
    if (ProductStore.productForm.productImages.length === 0) {
      ProductStore.checkValidation({ name: "productImages", value: true });
    } else {
      ProductStore.checkValidation({ name: "productImages", value: false });
    }
    if (ProductStore.productForm.howManyColor === "") {
      ProductStore.checkValidation({ name: "howManyColor", value: true });
    } else {
      ProductStore.checkValidation({ name: "howManyColor", value: false });
    }
    if (ProductStore.productForm.categoryID === "") {
      ProductStore.checkValidation({ name: "categoryID", value: true });
    } else {
      ProductStore.checkValidation({ name: "categoryID", value: false });
    }
    if (ProductStore.productForm.gender.length === 0) {
      ProductStore.checkValidation({ name: "gender", value: true });
    } else {
      ProductStore.checkValidation({ name: "gender", value: false });
    }
    if (ProductStore.productForm.tagID.length < 2) {
      ProductStore.checkValidation({ name: "tagID", value: true });
    } else {
      ProductStore.checkValidation({ name: "tagID", value: false });
    }
    if (ProductStore.productForm.deliverDays === "") {
      ProductStore.checkValidation({ name: "deliverDays", value: true });
    } else {
      ProductStore.checkValidation({ name: "deliverDays", value: false });
    }
    if (ProductStore.productForm.currentStock === "") {
      ProductStore.checkValidation({ name: "currentStock", value: true });
    } else {
      ProductStore.checkValidation({ name: "currentStock", value: false });
    }
    if (ProductStore.productForm.regularPrice === "") {
      ProductStore.checkValidation({ name: "regularPrice", value: true });
    } else {
      ProductStore.checkValidation({ name: "regularPrice", value: false });
    }

    if (
      ProductStore.productForm.productName === "" ||
      ProductStore.productForm.productContent === "" ||
      ProductStore.productForm.productImages.length === 0 ||
      ProductStore.productForm.howManyColor === "" ||
      ProductStore.productForm.categoryID === "" ||
      ProductStore.productForm.gender.length === 0 ||
      ProductStore.productForm.tagID.length < 2 ||
      ProductStore.productForm.regularPrice === "" ||
      ProductStore.productForm.deliverDays === "" ||
      ProductStore.productForm.currentStock === ""
    ) {
      SnackbarStore.setMassage({ value: "Fill all required field" });
      SnackbarStore.setIsOpen({ value: true });
      return false;
    }

    if (
      ProductStore.isSaleLabel === true ||
      ProductStore.isNewLabel === true ||
      ProductStore.productForm.includesTaxes === false
    ) {
      var count = 0;
      if (
        ProductStore.productForm.productSaleLabel === "" &&
        ProductStore.isSaleLabel === true
      ) {
        count++;
        ProductStore.checkValidation({ name: "productSaleLabel", value: true });
      } else {
        ProductStore.checkValidation({
          name: "productSaleLabel",
          value: false,
        });
      }
      if (
        ProductStore.productForm.productNewLabel === "" &&
        ProductStore.isNewLabel === true
      ) {
        count++;
        ProductStore.checkValidation({ name: "productNewLabel", value: true });
      } else {
        ProductStore.checkValidation({ name: "productNewLabel", value: false });
      }
      if (
        ProductStore.productForm.tax === "" &&
        ProductStore.productForm.includesTaxes === false
      ) {
        count++;
        ProductStore.checkValidation({ name: "tax", value: true });
      } else {
        ProductStore.checkValidation({ name: "tax", value: false });
      }
      if (count > 0) {
        SnackbarStore.setMassage({ value: "Fill all required field" });
        SnackbarStore.setIsOpen({ value: true });
        return false;
      }
    }

    // Call API
    var res = false;
    setIsLoading(true);
    if (params.productID !== undefined) {
      res = await ProductStore.updateProduct();
      SnackbarStore.setMassage({ value: "Update Successfully" });
    } else {
      res = await ProductStore.createProduct();
      SnackbarStore.setMassage({ value: "Create Successfully" });
    }
    setIsLoading(false);
    if (res) return navigate("/product");
  };

  return (
    <div className="manageProduct w-100">
      {/* for error */}
      <SnackbarAlert
        isOpen={SnackbarStore.isOpen}
        onClose={() => {
          SnackbarStore.setIsOpen({ value: false });
          SnackbarStore.setMassage({ value: "" });
        }}
        alertVariant="filled"
        alertSeverity="error"
        alertColor="error"
        massage={SnackbarStore.massage}
      />
      {/* for error */}
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Grid container>
        <Grid item xs={12}>
          <div className="heading">
            {params.productID !== undefined ? "Edit" : "Create a new Product"}
          </div>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={12}>
          <TwoBreadcrumb
            mainName="Product"
            mainLink="product"
            activeName={params.productID !== undefined ? "edit" : "New Product"}
          />
        </Grid>
      </Grid>

      <Grid container className="gridContainer">
        <Grid container item>
          <Grid
            container
            item
            xs={1}
            md={5}
            lg={5}
            display={{ xs: "none", lg: "block", sm: "none", md: "block" }}
            className="gridTitles"
          >
            <Grid item xs={12}>
              <h2>Details</h2>
              <p>Title, short description,image...</p>
            </Grid>
          </Grid>
          <Grid
            container
            item
            xs={12}
            md={7}
            sm={12}
            lg={7}
            spacing={3}
            className="gridContent"
            component="form"
          >
            <Grid item xs={12} className="gridContentTitle">
              <h2>Details</h2>
            </Grid>
            <Grid item xs={12}>
              <TextField
                required
                error={ProductStore.validateProductForm.productName}
                helperText={
                  ProductStore.validateProductForm.productName &&
                  "Name is required"
                }
                label="Product Name"
                variant="outlined"
                className="w-100"
                name="productName"
                value={ProductStore.productForm.productName}
                onChange={ProductStore.fillProductDataWithName}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Sub Description"
                multiline
                rows={4}
                className="w-100"
                name="productSubDescription"
                value={ProductStore.productForm.productSubDescription}
                onChange={ProductStore.fillProductDataWithName}
              />
            </Grid>
            <Grid item xs={12}>
              <Box component="p" className="infoText">
                Content *
              </Box>
              <QuillEditor
                id="productContent"
                value={ProductStore.productForm.productContent}
                onChange={(value) => ProductStore.fillProductContent({ value })}
              />
              {ProductStore.validateProductForm.productContent && (
                <div
                  style={{
                    fontSize: "var(--smallFontSize)",
                    fontWeight: 500,
                    color: "#D01110",
                    marginLeft: "15px",
                    marginTop: "5px",
                  }}
                >
                  Description is required
                </div>
              )}
            </Grid>
            <Grid item xs={12}>
              <Box component="p" className="infoText">
                Image *
              </Box>
              <Box
                className="fileUpload w-100"
                component="div"
                onClick={() => document.querySelector(".input-images").click()}
              >
                <Box
                  component="img"
                  sx={{
                    objectFit: "contain",
                    width: "100px",
                    height: "100px",
                  }}
                  className="upImage"
                  src={UploadLogoImage}
                />
                <h2>Select file</h2> {/* Drop or */}
                <p>Click browse thorough your machine</p>
                {/* Drop file here or */}
                <input
                  name="productImage"
                  type="file"
                  accept="image/*"
                  className="input-images"
                  hidden
                  style={{}}
                  multiple
                  onChange={async (e) => {
                    const { files } = e.target;
                    await ProductStore.fillProductImage({ files });

                    // local state
                    // const data = [];
                    // for (let i = 0; i < files.length; i++) {
                    //   data.push(URL.createObjectURL(files[i]));
                    // }
                    // setSelectImage((old) => [...old, ...data]);
                  }}
                />
              </Box>
              {ProductStore.validateProductForm.productImages && (
                <div
                  style={{
                    fontSize: "var(--smallFontSize)",
                    fontWeight: 500,
                    color: "#D01110",
                    marginLeft: "15px",
                    marginTop: "5px",
                  }}
                >
                  Images is required
                </div>
              )}
            </Grid>
            <Grid item container spacing={2}>
              {ProductStore.productForm.productImages &&
                ProductStore.productForm.productImages.map((item, index) => {
                  return (
                    <Grid
                      item
                      xs={4}
                      sm={3}
                      md={3}
                      lg={2}
                      key={index}
                      id={`grid-product-image-${index}`}
                    >
                      <Box className="selectedImageContainer">
                        <Tooltip title="Delete">
                          <IconButton
                            className="icon"
                            size="small"
                            onClick={() => {
                              ProductStore.removeProductImage({
                                removeItem:
                                  ProductStore.productForm.productImages[index],
                              });
                            }}
                          >
                            <CloseIcon />
                          </IconButton>
                        </Tooltip>
                        <Box
                          component="img"
                          src={`${PRODUCT_IMAGE_URL}${item}`}
                          className="productImages"
                          onError={(e) => {
                            const gridItem = document.getElementById(
                              `grid-product-image-${index}`
                            );
                            if (gridItem) {
                              gridItem.style.display = "none"; // Hide the entire grid item if image fails to load
                            }
                          }}
                        />
                      </Box>
                    </Grid>
                  );
                })}

              {ProductStore.imagesPreview &&
                ProductStore.imagesPreview.map((item, index) => (
                  <Grid item xs={4} sm={3} md={3} lg={2} key={index}>
                    <Box className="selectedImageContainer">
                      <Tooltip title="Delete">
                        <IconButton
                          className="icon"
                          size="small"
                          onClick={() => {
                            ProductStore.removeProductImage({
                              removeImagePreview: item,
                              removeFiles: ProductStore.imageFiles[index],
                            });
                          }}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                      <Box
                        component="img"
                        src={item}
                        className="productImages"
                      />
                    </Box>
                  </Grid>
                ))}
            </Grid>
          </Grid>
        </Grid>

        <Grid container item className="m-10">
          <Grid
            container
            item
            xs={1}
            md={5}
            lg={5}
            display={{ xs: "none", lg: "block", sm: "none", md: "block" }}
            className="gridTitles"
          >
            <Grid item xs={12}>
              <h2>Properties</h2>
              <p>Additional function and attributes...</p>
            </Grid>
          </Grid>
          <Grid
            container
            item
            xs={12}
            md={7}
            sm={12}
            lg={7}
            spacing={3}
            className="gridContent"
            component="form"
          >
            <Grid item xs={12} className="gridContentTitle">
              <h2>Properties</h2>
            </Grid>
            <Grid item xs={12} md={6} sm={12}>
              <TextField
                label="Product Code"
                variant="outlined"
                className="w-100"
                name="productCode"
                value={ProductStore.productForm.productCode}
                onChange={ProductStore.fillProductDataWithName}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label="Product SKU"
                variant="outlined"
                className="w-100"
                name="productSKU"
                value={ProductStore.productForm.productSKU}
                onChange={ProductStore.fillProductDataWithName}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              {/* <TextField
                type="number"
                label="Quantity"
                variant="outlined"
                className="w-100"
                name="howManyColor"
                value={ProductStore.productForm.howManyColor}
                onChange={ProductStore.fillProductDataWithName}
              /> */}
              <FormControl
                required
                fullWidth
                error={ProductStore.validateProductForm.howManyColor}
              >
                <InputLabel id="demo-simple-select-label">
                  How may color
                </InputLabel>
                <Select
                  label="Category"
                  name="howManyColor"
                  value={ProductStore.productForm.howManyColor}
                  onChange={ProductStore.fillProductDataWithName}
                >
                  {HowManyColorsUsed
                    ? HowManyColorsUsed.map((option) => (
                        <MenuItem value={option} key={option}>
                          {option}
                        </MenuItem>
                      ))
                    : data}
                </Select>
                {ProductStore.validateProductForm.howManyColor && (
                  <FormHelperText>Category is required</FormHelperText>
                )}
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl
                required
                fullWidth
                error={ProductStore.validateProductForm.categoryID}
              >
                <InputLabel id="demo-simple-select-label">Category</InputLabel>
                <Select
                  label="Category"
                  value={ProductStore.productForm.categoryID}
                  onChange={(e) => {
                    ProductStore.fillCategoryID({
                      id: e.target.value ? e.target.value : "",
                    });
                  }}
                >
                  {CategoryStore.mCategory
                    ? CategoryStore.mCategory.map((option) => (
                        <MenuItem value={option._id} key={option._id}>
                          {option.categoryName}
                        </MenuItem>
                      ))
                    : data}
                </Select>
                {ProductStore.validateProductForm.categoryID && (
                  <FormHelperText>Category is required</FormHelperText>
                )}
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <Autocomplete
                multiple
                className="w-100"
                value={ProductStore.productForm.productColors}
                id="productColors"
                options={ProductColors}
                disableCloseOnSelect
                renderOption={(props, option, { selected }) => (
                  <li {...props}>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={selected}
                    />
                    {option}
                  </li>
                )}
                limitTags={2}
                renderInput={(params) => (
                  <TextField {...params} label="Colors" placeholder="Colors" />
                )}
                onChange={(e, value) =>
                  ProductStore.fillProductDataWithAutoCompleteMultiple({
                    name: "productColors",
                    value: value,
                  })
                }
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Autocomplete
                multiple
                className="w-100"
                id="productSizes"
                value={ProductStore.productForm.productSizes}
                options={ProductSizes}
                disableCloseOnSelect
                renderOption={(props, option, { selected }) => (
                  <li {...props}>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={selected}
                    />
                    {option}
                  </li>
                )}
                limitTags={2}
                renderInput={(params) => (
                  <TextField {...params} label="Sizes" placeholder="Sizes" />
                )}
                onChange={(e, value) =>
                  ProductStore.fillProductDataWithAutoCompleteMultiple({
                    name: "productSizes",
                    value: value,
                  })
                }
              />
            </Grid>
            <Grid item xs={12}>
              <Box component="p" className="infoText">
                Gender *
              </Box>
              <FormGroup sx={{ display: "flex", flexDirection: "row" }}>
                <FormControlLabel
                  checked={ProductStore.M}
                  control={<Checkbox />}
                  label="Men"
                  value="M"
                  name="gender"
                  onClick={(value, e) => {
                    value.target.checked
                      ? ProductStore.pushGender({ value: value.target.value })
                      : ProductStore.popGender({ value: value.target.value });
                  }}
                />
                <FormControlLabel
                  checked={ProductStore.W}
                  control={<Checkbox />}
                  label="Women"
                  value="W"
                  name="gender"
                  onClick={(value, e) => {
                    value.target.checked
                      ? ProductStore.pushGender({ value: value.target.value })
                      : ProductStore.popGender({ value: value.target.value });
                  }}
                />
                <FormControlLabel
                  checked={ProductStore.K}
                  control={<Checkbox />}
                  label="Kids"
                  value="K"
                  name="gender"
                  onClick={(value, e) => {
                    value.target.checked
                      ? ProductStore.pushGender({ value: value.target.value })
                      : ProductStore.popGender({ value: value.target.value });
                  }}
                />
              </FormGroup>
              {ProductStore.validateProductForm.gender && (
                <div
                  style={{
                    fontSize: "var(--smallFontSize)",
                    fontWeight: 500,
                    color: "#D01110",
                    marginLeft: "15px",
                    marginTop: "5px",
                  }}
                >
                  Gender is required
                </div>
              )}
            </Grid>
            {/* <Grid item xs={12}>
              <Box component="p" className="infoText">
                Gender *
              </Box>
              <FormControl>
                <RadioGroup
                  sx={{ display: "flex", flexDirection: "row" }}
                  aria-labelledby="demo-controlled-radio-buttons-group"
                  name="gender"
                  value={ProductStore.productForm.gender}
                  onChange={ProductStore.fillProductDataWithName}
                >
                  <FormControlLabel
                    value="W"
                    control={<Radio />}
                    label="Women"
                  />
                  <FormControlLabel value="M" control={<Radio />} label="Men" />
                  <FormControlLabel
                    value="K"
                    control={<Radio />}
                    label="Kids"
                  />
                </RadioGroup>
              </FormControl>
              {ProductStore.validateProductForm.gender && (
                <div
                  style={{
                    fontSize: "var(--smallFontSize)",
                    fontWeight: 500,
                    color: "#D01110",
                    marginLeft: "15px",
                    marginTop: "5px",
                  }}
                >
                  Gender is required
                </div>
              )}
            </Grid> */}
            <Grid item xs={12}>
              <Autocomplete
                multiple
                fullWidth
                name="tagID"
                options={
                  SearchTagStore.searchTags
                    ? SearchTagStore.searchTags.sort((a, b) => {
                        return a.tag.localeCompare(b.tag);
                      })
                    : []
                }
                disableCloseOnSelect
                value={selectedTags}
                getOptionLabel={(option) => option.tag}
                renderOption={(props, option, { selected }) => (
                  <li {...props}>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={selected}
                    />
                    {option.tag}
                  </li>
                )}
                renderInput={(params) => (
                  <TextField {...params} label="Tags" required />
                )}
                onChange={(e, value) => {
                  const data = value.map((item) => item._id);
                  ProductStore.fillProductDataWithAutoCompleteMultiple({
                    name: "tagID",
                    value: data,
                  });
                }}
              />
              {ProductStore.validateProductForm.tagID && (
                <div
                  style={{
                    fontSize: "var(--smallFontSize)",
                    fontWeight: 500,
                    color: "#D01110",
                    marginLeft: "15px",
                    marginTop: "5px",
                  }}
                >
                  Minimum 2 Tags are required
                </div>
              )}
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                inputProps={{ inputMode: "numeric" }}
                label="Current Stock"
                variant="outlined"
                required
                className="w-100"
                name="currentStock"
                value={ProductStore.productForm.currentStock}
                onChange={(e) => {
                  if (!isNaN(e.target.value)) {
                    ProductStore.fillProductDataWithName(e);
                  }
                }}
                error={ProductStore.validateProductForm.currentStock}
                helperText={
                  ProductStore.validateProductForm.currentStock &&
                  "Delivery days is required"
                }
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                inputProps={{ inputMode: "numeric" }}
                label="How many days to deliver this product"
                variant="outlined"
                required
                className="w-100"
                name="deliverDays"
                value={ProductStore.productForm.deliverDays}
                onChange={(e) => {
                  if (!isNaN(e.target.value)) {
                    ProductStore.fillProductDataWithName(e);
                  }
                }}
                error={ProductStore.validateProductForm.deliverDays}
                helperText={
                  ProductStore.validateProductForm.deliverDays &&
                  "Delivery days is required"
                }
              />
            </Grid>
            <Grid item xs={12}>
              <Divider sx={{ border: "0.1px dashed var(--grayText)" }} />
            </Grid>
            <Grid item xs={3} sm={2}>
              <Box
                component="div"
                sx={{
                  width: "100%",
                  justifyContent: "center",
                  alignItems: "center",
                  alignContent: "center",
                  height: "100%",
                  display: "flex",
                }}
              >
                <FormControlLabel
                  name="isSaleLabel"
                  checked={ProductStore.isSaleLabel}
                  control={<IOSSwitch sx={{ m: 1 }} />}
                  onChange={(e) =>
                    ProductStore.setSwitchOnOrOff({
                      name: e.target.name,
                      value: !ProductStore.isSaleLabel,
                    })
                  }
                />
              </Box>
            </Grid>
            <Grid item xs={9} sm={10}>
              <TextField
                required={ProductStore.isSaleLabel && true}
                error={ProductStore.validateProductForm.productSaleLabel}
                helperText={
                  ProductStore.validateProductForm.productSaleLabel &&
                  "Sale label is required"
                }
                disabled={ProductStore.isSaleLabel ? false : true}
                type="text"
                label="Sale Label"
                variant="outlined"
                className="w-100"
                name="productSaleLabel"
                value={ProductStore.productForm.productSaleLabel}
                onChange={ProductStore.fillProductDataWithName}
              />
            </Grid>
            <Grid item xs={3} sm={2}>
              <Box
                component="div"
                sx={{
                  width: "100%",
                  justifyContent: "center",
                  alignItems: "center",
                  alignContent: "center",
                  height: "100%",
                  display: "flex",
                }}
              >
                <FormControlLabel
                  name="isNewLabel"
                  checked={ProductStore.isNewLabel}
                  control={<IOSSwitch sx={{ m: 1 }} />}
                  onChange={(e) =>
                    ProductStore.setSwitchOnOrOff({
                      name: e.target.name,
                      value: !ProductStore.isNewLabel,
                    })
                  }
                />
              </Box>
            </Grid>
            <Grid item xs={9} sm={10}>
              <TextField
                required={ProductStore.isNewLabel && true}
                error={ProductStore.validateProductForm.productNewLabel}
                helperText={
                  ProductStore.validateProductForm.productNewLabel &&
                  "New label is required"
                }
                disabled={ProductStore.isNewLabel ? false : true}
                type="text"
                label="New Label"
                variant="outlined"
                className="w-100"
                name="productNewLabel"
                value={ProductStore.productForm.productNewLabel}
                onChange={ProductStore.fillProductDataWithName}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid container item className="m-10">
          <Grid
            container
            item
            xs={1}
            md={5}
            lg={5}
            display={{ xs: "none", lg: "block", sm: "none", md: "block" }}
            className="gridTitles"
          >
            <Grid item xs={12}>
              <h2>Pricing</h2>
              <p>Price related inputs</p>
            </Grid>
          </Grid>
          <Grid
            container
            item
            xs={12}
            md={7}
            sm={12}
            lg={7}
            spacing={3}
            className="gridContent"
            component="form"
          >
            <Grid item xs={12} className="gridContentTitle">
              <h2>Pricing</h2>
            </Grid>
            <Grid item xs={12}>
              <TextField
                required
                error={ProductStore.validateProductForm.regularPrice}
                helperText={
                  ProductStore.validateProductForm.regularPrice &&
                  "Price should not be ₹0"
                }
                label="Regular Price"
                variant="outlined"
                inputProps={{ inputMode: "numeric" }}
                className="w-100"
                name="regularPrice"
                placeholder="0.00"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <CurrencyRupeeIcon
                        sx={{ color: "var(--grayText)", fontSize: "18px" }}
                      />
                    </InputAdornment>
                  ),
                }}
                value={ProductStore.productForm.regularPrice}
                onChange={(e) => {
                  if (!isNaN(e.target.value)) {
                    ProductStore.fillProductDataWithName(e);
                  }
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Sale Price"
                variant="outlined"
                inputProps={{ inputMode: "numeric" }}
                className="w-100"
                name="salePrice"
                placeholder="0.00"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <CurrencyRupeeIcon
                        sx={{ color: "var(--grayText)", fontSize: "18px" }}
                      />
                    </InputAdornment>
                  ),
                }}
                value={ProductStore.productForm.salePrice}
                onChange={(e) => {
                  if (!isNaN(e.target.value)) {
                    ProductStore.fillProductDataWithName(e);
                  }
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Box className="w-100 flex" component="div">
                <FormControlLabel
                  name="includesTaxes"
                  checked={ProductStore.productForm.includesTaxes}
                  control={<IOSSwitch sx={{ m: 1 }} />}
                  onChange={() => {
                    ProductStore.setIncludesTaxes({
                      value: !ProductStore.productForm.includesTaxes,
                    });
                  }}
                />
                <p style={{ fontSize: "16px" }}>Price includes taxes</p>
              </Box>
            </Grid>
            {ProductStore.productForm.includesTaxes ? null : (
              <Grid item xs={12}>
                <TextField
                  required
                  error={ProductStore.validateProductForm.tax}
                  helperText={
                    ProductStore.validateProductForm.tax &&
                    "Price should not includes taxes then tax is required"
                  }
                  label="Tax (%)"
                  variant="outlined"
                  type="number"
                  className="w-100"
                  name="tax"
                  placeholder="0.00"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <PercentIcon
                          sx={{ color: "var(--grayText)", fontSize: "18px" }}
                        />
                      </InputAdornment>
                    ),
                  }}
                  value={ProductStore.productForm.tax}
                  onChange={ProductStore.fillProductDataWithName}
                />
              </Grid>
            )}
          </Grid>
        </Grid>

        <Grid
          container
          item
          xs={12}
          mt="20px"
          sx={{
            justifyContent: "space-between",
            display: "flex",
            alignItems: "center",
          }}
          className="btnContainer"
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              fontWeight: "700",
            }}
          >
            <FormControlLabel
              name="publish"
              checked={ProductStore.productForm.publish}
              control={<IOSSwitch sx={{ m: 1 }} />}
              onChange={(e) =>
                ProductStore.setSwitchOnOrOff({
                  name: e.target.name,
                  value: !ProductStore.productForm.publish,
                })
              }
            />
            Publish
          </Box>
          <Button variant="contained" className="btn" onClick={handleClick}>
            {params.productID !== undefined ? "Save Changes" : "Create Product"}
          </Button>
        </Grid>
        {/* <Grid container item className="m-10">
          <div dangerouslySetInnerHTML={{ __html: ProductStore.productForm.productContent }}></div>
        </Grid> */}
      </Grid>
    </div>
  );
};

export default ManageProduct;
